import React, {useEffect, useState} from 'react'

const CatalogueCheckboxDisc = ({filter, updateFilters}) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(filter)
  }, [filter]);


  return (
    <label>
      <input type="checkbox"
             className="checkbox"
             name="checkbox-disc"
             checked={checked}
             onChange={() => updateFilters(!checked)}/>
      <span className="checkbox-discount"/>
      <span className="text-discount">Со скидкой</span>
    </label>
  )
};

export default CatalogueCheckboxDisc
